<template>
  <div>
    <list
      :params="params"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :drag="false"
      :itemLink="itemLink"
      :filters="filters"
      :setLink="setLink"
      :openItem="false"
      :fields="fields"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </div>
</template>
<script>
export default {
  name: "products",
  props: ["id"],
  created() {
    this.itemLink = `lessonplans/${this.id}/themes`;
    this.setLink = `lessonplans/${this.id}/themes`;
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      params: {},
      filters: [],
      modalCreate: "lessonplan",
      fields: [
        {
          col: "col-12 col-md-4",
          key: "position",
          label: "Номер темы",
          type: "field",
          textType: "number",
        },
        {
          col: "col-12 col-md-8",
          key: "name",
          label: "Название темы",
          type: "field",
          textType: "text",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_subtheme",
      itemLink: "",
      setLink: "",
      columns: [
        {
          key: "position",
          title: "Номер темы",
          checkbox: false,
          inputSet: true,
          sortBy: "position",
        },
        {
          key: "title",
          title: "Название темы",
          checkbox: false,
        },
      
   
        {
          key: "created_at",
          title: "Создан",

          sortBy: "created_at",
          dateTimeFormat: true,
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>